declare global {
  interface Window {
    gtag: Function
  }
}
interface TrackingEvent {
  action: string
  category?: string | null
  label?: string | null
  value?: string | null
}

export const trackEvent = (event: TrackingEvent): void => {
  const { action, category, label, value } = event

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}

export const setPersistentValues = (values: object): void => {
  window.gtag('set', values)
}
